import {UserProfile} from 'APIs/letrusAPI/user/types';

// Whether the student has already dismissed the AI-usage notice, account-wide
// — persisted in the backend (ai_notice_seen_at on UserProfile), not
// per-composition and not just client-side. Once seen on any device, it
// must not reappear on a different device/browser or after clearing cache.
export function useHasSeenAiNotice(
  userProfile: UserProfile | undefined,
): boolean {
  return !!userProfile?.ai_notice_seen_at;
}

export default useHasSeenAiNotice;
